// This captures the route before the keycloak initializer starts
// This will be removed once keycloak supports silent sso login
(function () {
  const currentUrl = window.location.pathname + window.location.search + window.location.hash;
  if (
    currentUrl &&
    currentUrl !== '/' &&
    !currentUrl.includes('state=') &&
    !currentUrl.includes('session_state=') &&
    !currentUrl.includes('code=') &&
    !currentUrl.startsWith('/register') &&
    !currentUrl.startsWith('/forgot-password') &&
    !currentUrl.startsWith('/reset-password')
  ) {
    sessionStorage.setItem('postLoginRedirect', currentUrl);
  }
})();
